export default function FinalDownloadsPanel({ slug, finals, adminGalleryId }) {
  const uploaded = finals?.uploadedFinals || [];
  const proofSelections = finals?.proofSelections || [];
  const visibleItems = uploaded.length ? uploaded : proofSelections;
  const mode = uploaded.length ? 'finale High-Res Dateien' : 'als final markierte Proofs';
  const downloadAllUrl = adminGalleryId
    ? `/api/admin/galleries/${adminGalleryId}/download-all`
    : `/api/gallery/${slug}/download-all`;

  return (
    <section className="final-panel">
      <div>
        <p className="mono-label">Delivery</p>
        <h2>Finale Bilder</h2>
        <p>
          Dieser Bereich nutzt {mode}. Sobald separate High-Res-Dateien hochgeladen sind, werden diese für den
          ZIP-Download priorisiert.
        </p>
      </div>
      {visibleItems.length ? (
        <>
          <a className="download-all" href={downloadAllUrl}>
            Alle finalen Bilder als ZIP laden
          </a>
          <div className="final-list">
            {visibleItems.map((item) => (
              <a href={item.downloadUrl || `${item.originalSrc}?download=1`} key={item.id}>
                <span>{item.filename}</span>
                <small>{item.fileSize ? `${Math.round(item.fileSize / 1024 / 1024)} MB` : item.orientation}</small>
              </a>
            ))}
          </div>
        </>
      ) : (
        <div className="proof-empty">
          <p className="mono-label">Nothing delivered</p>
          <h3>Noch keine finalen Bilder bereitgestellt.</h3>
        </div>
      )}
    </section>
  );
}
